import axios from 'axios'
const http = axios.create({
})
http.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
http.interceptors.response.use((res) => {
  if (res.status === 200) {
    return res.data
  } else {
    return {status: -1}
  }
}, (error) => {
  return error
})
export default {
  install (vue, opt) {
    vue.prototype.$http = http
  }
}
